import TATSettlementReport from 'src/containers/HardshipAllowanceReports/TATSettlementReport';
import * as XLSX from 'xlsx';

export const USER_ROLES = {
  Doctor: 'Doctor',
  IO_Reviewer: 'IO_Reviewer',
  IO_Reviewer_Update: 'IO_Reviewer_Update',
  DOC_Reviewer: 'DOC_Reviewer',
  SDOC_Reviewer: 'SDOC_Reviewer',
  FO_Reviewer: 'FO_Reviewer',
  Patient: 'Patient',
  ADMIN_REVIEWER: 'ADMIN_REVIEWER',
  Call_Logs: 'Call_Logs',
  OVERDUE_Reviewer: 'OVERDUE_Reviewer',
  Higher_Level_Reviewer: 'higher_level_reviewer',
  Claim_Manager_Reviewer: 'claim_manager_reviewer',
  Claim_Download_Upload: 'claim_download_upload',
  Hindi_Prescription: 'hindi_prescription',
  Insurance_Policy_View: 'insurance_policy_view',
  Claim_Manager: 'claim_manager',
  External_Claim: 'external_claim',
  ASSET_IO_REVIEWER: 'ASSET_IO_REVIEWER',
  Death_Verification: 'death_verification',
  Hierarchy_ClaimBucket_Master: 'Hierarchy_ClaimBucket_Master',
  reimbursement_ui_v2: 'reimbursement_ui_v2',
  Raise_Claim: 'raise_claim',
  View_draft_claim: 'view_draft_claim',
  Stage_wise_action_report: 'stage_wise_action_report',
  Partner_wise_action_report: 'partner_wise_action_report',
  Consolidated_report: 'consolidated_report',
  TAT_settlement_report: 'TAT_settlement_report',
  TAT_InProgress_report: 'TAT_InProgress_report',
  CLAIM_STATUS_MODIFIER: 'CLAIM_STATUS_MODIFIER',
  STATUS_REVIEWER: 'STATUS_REVIEWER',
  DATA_OPERATOR: 'DATA_OPERATOR',
  DATA_OPERATOR_MANAGER: 'DATA_OPERATOR_MANAGER',
  PENNYDROP_REPORT_VIEWER: 'PENNYDROP_REPORT_VIEWER',
  RISK_ASSESSMENT: 'risk_assessment'
};

export const sequenceType = {
  Ascending: 'ASC',
  Descending: 'DESC'
};

export const dataToXLSX = (data) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const xlsxBuffer = XLSX.write(workbook, {
    type: 'buffer',
    bookType: 'xlsx'
  });

  return xlsxBuffer;
};

export const handleDownload = (data) => {
  const xlsxData = dataToXLSX(data);
  const blob = new Blob([xlsxData], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = 'table_data.xlsx';
  downloadLink.click();
  URL.revokeObjectURL(downloadLink.href);
};

export const handleDownloadPennydropReport = (data) => {
  const base64Data = data;

  // Convert the Base64 string to a binary array
  const binaryString = atob(base64Data);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob from the binary data
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  // Create a link element
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'downloaded_file.xlsx'; // Set the file name

  // Append the link to the body (required for Firefox)
  document.body.appendChild(link);

  // Trigger the download
  link.click();

  // Clean up and remove the link
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
